<template>
  <div class="justify-content-center">
    <div id="pdf-filers">
      <div class="row row-filter mt-2 mb-3 mt-md-0">
        <div id="div-therapist" class="col-12 col-lg-4">
          <h3 class="row-title">
            {{'report.choose_therapist' | trans }}
          </h3>

          <select-with-pager id="mdc-therapist"
                             name="therapist"
                             class="load_more__select"
                             :label="'displayName'"
                             :selected=therapistId
                             :options="therapists"
                             :class="{'is-invalid': errors.has('therapist')}"
                             :filterable="false"
                             :searchable="false"
                             :loading=loading
                             :isLastPage=isLastPage
                             v-on:next-page="nextPage"
                             v-on:set-selected="onSetSelected"
                             v-bind:getOptionTitle="getOptionTitle"
                             v-bind:isLast="isLast"
          >

          </select-with-pager>
          <span id="span-b" class="description-row">{{'report.description_choose_therapist' | trans }}</span>

        </div>

        <div class="col-12 mt-3 mt-lg-0 col-lg-8">

          <h3 class="row-title">
            {{'report.choose_period' | trans }} <sup class="text-danger">*</sup>
          </h3>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="datepicker datepicker__width">
            <span class="datepicker__label">
                 {{'report.range_from' | trans }}
            </span>

                <v-date-picker
                  v-model='rangeDateStart'
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  :max-date="maxDateStart"
                  :min-date="minDateStart">
                </v-date-picker>

                <mdc-icon icon="date_range"></mdc-icon>
              </div>
            </div>

            <div class="col-12 mt-2 mt-lg-0 col-lg-6">
              <div class="datepicker datepicker__width right">
            <span class="datepicker__label">
                 {{'report.range_end' | trans }}
            </span>

                <v-date-picker
                  v-model='rangeDateEnd'
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  :max-date="maxDateStart"
                  :min-date="rangeDateStart">
                </v-date-picker>

                <mdc-icon icon="date_range"></mdc-icon>
              </div>
            </div>
            <div class="col-12">
              <span class="description-row">{{'report.description_choose_period' | trans }}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-3 text-right">
        <button type="button" :disabled="isLoading"
                class="btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="onSendRequest()">
          {{'report.draw_report' | trans }}
        </button>
      </div>
    </div>
    <loader v-if="pdfProcess"/>
    <loader class="table-loader" v-if="isLoading"/>
    <div class="row" v-if="showTable && !isLoading">
      <div id="pdf-client-table" class="col-12">
        <h3 class="table-title" v-if="therapistId">{{'report.info_therapist' |
          trans }}: {{therapist}}</h3>
        <h3 class="table-title" v-if="!therapistId">{{'report.info_therapists' |
          trans }}</h3>
        <table class="table table-sm">
          <thead class="thead-light">
          <tr>
            <th>{{'user.therapist' | trans}}</th>
            <th>{{'report.bids_new' | trans}}</th>
            <th>{{'report.bids_created' | trans}}</th>
            <th>{{'report.bids_completed' | trans}}</th>
            <th>{{'report.bids_overdue' | trans}}</th>
            <th>{{'report.clients_count' | trans}}</th>
            <th>{{'report.total_time' | trans}}</th>
          </tr>
          </thead>
          <tbody class="gray-700">
          <tr v-for="item in therapistStatistics" v-if="therapistStatistics.length > 0">
            <td>{{item.displayName}}</td>
            <td>{{item.newBidCount}}</td>
            <td>{{item.createdBidCount}}</td>
            <td>{{item.processedBidCount}}</td>
            <td>{{item.overdueBidCount}}</td>
            <td>{{item.totalClientCount}}</td>
            <td>{{timeDuration(item.hoursWithClients)}}</td>
          </tr>
          <tr class="text-center" v-if="therapistStatistics.length === 0">
            <td colspan="7"><h5>{{'user.no_data' | trans }}</h5></td>
          </tr>
          </tbody>
        </table>

        <nav class="nav justify-content-center justify-content-md-start"
             v-if="paginate.lastPage > 1">
          <paginate :page-count="paginate.lastPage"
                    :page-range="paginate.pageRange"
                    :margin-pages="paginate.marginPages"
                    :force-page="paginate.forcePage"
                    :click-handler="onPaginationClick"
                    :container-class="'pagination pagination-sm'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'">
            <span slot="prevContent" class="page-link">&laquo;</span>
            <span slot="nextContent" class="page-link">&raquo;</span>
          </paginate>
        </nav>


        <h3 class="table-title mt-2" v-if="therapist">{{'user.clients' | trans
          }}</h3>
        <div class="table-responsive">
          <table class="table table-sm" v-if="therapist">
            <thead class="thead-light">
            <tr>
              <th>{{'user.clients' | trans}}</th>
              <th>{{'report.total_time' | trans}}</th>
            </tr>
            </thead>
            <tbody class="gray-700">
            <tr v-for="item in clientStatistics">
              <td>{{item.name}}</td>
              <td>{{timeDuration(item.hours)}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <nav class="nav justify-content-center justify-content-md-start"
             v-if="paginateClient.lastPage > 1">
          <paginate :page-count="paginateClient.lastPage"
                    :page-range="paginateClient.pageRange"
                    :margin-pages="paginateClient.marginPages"
                    :force-page="paginateClient.forcePage"
                    :click-handler="onPaginationClientClick"
                    :container-class="'pagination pagination-sm'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'">
            <span slot="prevContent" class="page-link">&laquo;</span>
            <span slot="nextContent" class="page-link">&raquo;</span>
          </paginate>
        </nav>
      </div>
      <div class="col-12 mt-3 text-right">
        <button type="button" v-if="!isMobile"
                class="btn btn-blue mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="generatePdf()">
          {{'report.download_pdf' | trans}}
        </button>
        <button type="button"
                :disabled="isSaveDisable"
                class="btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="saveRequest()">
          {{'report.save_report' | trans }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import axios from 'axios';
  import forIn from 'lodash/forIn';
  import Constants from '../../undesirableBehavior/Constants';
  import moment from 'moment';
  import {pagination} from '../../../common/mixins/pagination';
  import lang from '../../../lang/translator';
  import Loader from '../../loader/components/Loader';
  import PdfReportTherapist from '../../reports/components/PdfReportTherapist';
  import selectWithPager from '../../../common/selectWithPager/components/SelectWithPager';
  import toInteger from 'lodash/toInteger';

  export default {
    name: 'TherapistList',
    props: {
      'isEdit': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'id': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'startDate': {
        type: [Object],
      },
      'endDate': {
        type: [Object],
      },
    },
    data() {
      return {
        apiUrl: '/users/therapists/',
        apiStaticUrl: '/users/statistics/therapists',
        apiSaveUrl: '/statistics/reports/therapists/',
        therapists: [],
        therapist: '',
        therapistId: null,
        perPage: 10,
        page: 1,
        rangeDateStart: new Date(),
        rangeDateEnd: new Date(),
        pdfProcess: false,
        minDateStart: this.getMinDateStart(new Date()),
        maxDateStart: this.getMaxDateStart(new Date()),
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        showTable: false,
        therapistStatistics: null,
        paginateData: null,
        clientStatistics: null,
        paginateClientData: null,
        paginateClient: {
          perPage: 10,
          page: 1,
          forcePage: 0,
          lastPage: 0,
          pageRange: 3,
          marginPages: 2,
        },
        afterSend: false,
        isSaveDisable: false,
        isLoading: false,
        loading: false,
        lastId: null,
        isLastPage: false,
      };
    },
    mixins: [pagination],
    components: {
      Loader,
      PdfReportTherapist,
      selectWithPager
    },
    created() {
      if (this.isEdit) {
        this.rangeDateStart = moment(this.startDate.date)._d
        this.rangeDateEnd = moment(this.endDate.date)._d
        this.isSaveDisable = true;
      } else {
        let dt = new Date()
        let date = new Date(dt.getFullYear(), (dt.getMonth() - 1), dt.getDate())
        this.rangeDateStart = date
      }
      this.getTherapists();
    },
    methods: {
      timeDuration(time) {
        let min = time*60;
        let minDuration = toInteger(min);
        let secDuration = toInteger(min*60 - minDuration*60);
        let timeDuration = time ? minDuration + lang.get('report.min') + ' ' + secDuration  + lang.get('report.sec') : 0 + lang.get('report.min');

        return timeDuration;
      },

      nextPage: async function () {
        if (!this.isLastPage) {
          this.loading = true;
          let response = await axios.get(this.apiUrl, {
            params: {
              perPage: this.perPage,
              page: this.page,
            },
          });

          response.data.data.items.forEach((item) => {
            this.therapists.push(item)
          });

          this.loading = false;
          this.lastId = this.therapists[this.therapists.length - 1].id;
          if (response.data.data.lastPage != this.page) {
            this.page++;
          } else {
            this.isLastPage = true;
          }
        }
      },

      onSetSelected: function (selected) {
        this.therapistId = selected;
      },

      getTherapists: async function () {
        try {
          let response = await axios.get(this.apiUrl, {
            params: {
              perPage: this.perPage,
              page: this.page,
            },
          });
          this.therapists = response.data.data.items;
          this.lastId = this.therapists[this.therapists.length - 1].id;

          if (response.data.data.hasMorePages) {
            this.page++;
          } else {
            this.isLastPage = true;
          }

          if (this.isEdit) {
            if (this.id) {
              this.getTherapist(this.id)
            } else{
              this.onSendRequest();
              this.afterSend = true;
            }
          }
        } catch (error) {
          console.dir(error);
        }
      },
      getTherapist: async function (id) {
        let that = this;
        let response = await axios.get(this.apiUrl+id);
        this.therapistId = response.data.data;

        if (response){
          this.onSendRequest();
          this.afterSend = true;
        }
      },
      async onPaginationClick(pageNum) {
        this.onPaginationBtnClick(pageNum);
        let response = await axios.get(
          `${this.apiStaticUrl}/${this.paginate.perPage}/${pageNum}`, {
            params: {
              startDate: this.rangeDateStartTimestamp,
              endDate: this.rangeDateEndTimestamp,
            },
          });
        this.therapistStatistics = response.data.data.items;
      },
      async onPaginationClientClick(pageNum) {
        this.paginateClient.page = pageNum;
        this.paginateClient.forcePage = pageNum - 1;
        let therapistId = this.therapistId ? this.therapistId.id : null
        let response = await axios.get(this.apiStaticUrl + '/' + therapistId + '/clients/' + this.paginateClient.perPage + '/' + this.paginateClient.page, {
          params: {
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp,
          },
        });
        this.clientStatistics = response.data.data.items;
      },
      getTherapistStatistics: async function (id) {
        let response;
        this.therapistStatistics = [];
        try {
          if (id) {
            response = await axios.get(this.apiStaticUrl + '/' + id, {
              params: {
                startDate: this.rangeDateStartTimestamp,
                endDate: this.rangeDateEndTimestamp,
              },
            });
            if (response.data.data instanceof Object && !(response.data.data instanceof Array)) {
              this.therapistStatistics.push(response.data.data);
            }
          } else {
            response = await axios.get(
              `${this.apiStaticUrl}/${500}/${this.paginate.page}`,
              {
                params: {
                  startDate: this.rangeDateStartTimestamp,
                  endDate: this.rangeDateEndTimestamp,
                },
              });
            this.therapistStatistics = response.data.data.items;
          }

          this.paginateData = response.data.data;
          this.isLoading = false;

        } catch (error) {
          console.dir(error);
        }
      },
      getClientStatistics: async function (id) {
        let response;
        try {
          if (id) {
            response = await axios.get(this.apiStaticUrl + '/' + id + '/clients/' + this.paginateClient.perPage + '/' + this.paginateClient.page, {
              params: {
                startDate: this.rangeDateStartTimestamp,
                endDate: this.rangeDateEndTimestamp,
              },
            });
            this.clientStatistics = response.data.data.items;
            this.paginateClientData = response.data.data;

          }
        } catch (error) {
          console.dir(error);
        } finally {

        }
      },
      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
          date.getDate());
        return minDateStart;
      },
      getMaxDateStart: function(date) {
        let minDateStart = new Date(date.getFullYear(), date.getMonth(),
            (date.getDate()+2));
        return minDateStart;
      },
      findTherapistById: function (id) {
        let that = this;
        forIn(this.therapists, function (item) {
          if (item.id == id) {
            that.therapist = item.displayName;
          }
        });
      },
      onSendRequest() {
        this.isLoading = true;
        if (this.afterSend) {
          this.isSaveDisable = false
        }
        let therapistId = this.therapistId ? this.therapistId.id : null
        this.therapist = therapistId ? this.therapistId.displayName : ''
        this.getTherapistStatistics(therapistId);
        this.getClientStatistics(therapistId);
        this.showTable = true;
      },
      setClientPaginate: function (data) {
        this.paginateClient.perPage = data.perPage;
        this.paginateClient.page = data.currentPage;
        this.paginateClient.lastPage = data.lastPage;
      },
      async saveRequest() {
        let title = this.therapistId ? lang.get('report.info_therapist') + ' ' + this.therapist : lang.get('report.info_therapists');
        this.pdfProcess = true;
        let isSaved = await axios.post(this.apiSaveUrl, {
          "title": title,
          "startDate": this.rangeDateStartTimestamp,
          "endDate": this.rangeDateEndTimestamp,
          "therapistId": this.therapistId ? this.therapistId.id : null
        });

        if (isSaved) {
          this.$router.push({name: 'archive-reports'});
          this.pdfProcess = false;
        }
      },
      async generatePdf() {
        this.pdfProcess = true;
        let uri = this.therapistId ? '/users/therapists/export/' + this.therapistId.id : '/users/therapists/export';
        let response = await axios.post(uri, {
          "startDate": this.rangeDateStartTimestamp,
          "endDate": this.rangeDateEndTimestamp,
        });
        let hash = response.data.data.hash;
        let url = process.env.APP_URL + `/users/reports/download?hash=${hash}`;
        let link = document.createElement("a");
        link.href = url;
        let node = document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          node.remove();
          this.pdfProcess = false;
        });
      },
      getOptionTitle: function ({option}) {
        return option.displayName;
      },
      isLast: function ({option}) {
        return option.id == this.lastId;
      },
    },
    computed: {
      ...mapGetters('auth', [
        'isBCBA',
      ]),
      ...mapState([
        'route',
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).unix() +
          (Math.abs(this.rangeDateStart.getTimezoneOffset()) *
            Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).unix() +
          (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
            Constants.SECONDS_PER_MINUTE);
      },
    },
    watch: {
      paginateData() {
        this.setPaginate(this.paginateData);
      },
      paginateClientData() {
        this.setClientPaginate(this.paginateClientData);
      },
      rangeDateStart(newValue, oldValue) {
        if (!newValue) {
          this.rangeDateStart = oldValue;
        }
      },
      rangeDateEnd(newValue, oldValue) {
        if (!newValue) {
          this.rangeDateEnd = oldValue;
          this.minDateStart = this.getMinDateStart(oldValue);
        } else {
          this.minDateStart = this.getMinDateStart(newValue);
        }
      }
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/reports/components/TherapistList.vue